/**
 * Doubled neon-line geometric border frame.
 * Outer lines are dim gold, inner lines are bright gold — creates a broadcast monitor feel.
 * Extracted from broadcast-summary.tsx PanelFrame.
 */
export function PanelFrame() {
  const gold = "oklch(0.85 0.28 85)"
  const goldDim = "oklch(0.85 0.28 85 / 0.5)"
  return (
    <div className="pointer-events-none absolute -inset-2.5" aria-hidden="true">
      {/* Top */}
      <div className="absolute top-0 right-0 left-0 h-[5px]">
        <span
          className="absolute top-0 right-5 left-5 h-px opacity-50"
          style={{ background: goldDim }}
        />
        <span
          className="absolute right-3.5 bottom-0 left-3.5 h-px"
          style={{ background: gold }}
        />
      </div>
      {/* Left */}
      <div className="absolute top-0 bottom-0 left-0 w-[5px]">
        <span
          className="absolute top-5 bottom-5 left-0 w-px"
          style={{ background: goldDim }}
        />
        <span
          className="absolute top-3.5 right-0 bottom-3.5 w-px"
          style={{ background: gold }}
        />
      </div>
      {/* Right */}
      <div className="absolute top-0 right-0 bottom-0 w-[5px]">
        <span
          className="absolute top-3.5 bottom-3.5 left-0 w-px"
          style={{ background: gold }}
        />
        <span
          className="absolute top-5 right-0 bottom-5 w-px"
          style={{ background: goldDim }}
        />
      </div>
      {/* Bottom */}
      <div className="absolute right-0 bottom-0 left-0 h-[5px]">
        <span
          className="absolute top-0 right-3.5 left-3.5 h-px"
          style={{ background: gold }}
        />
        <span
          className="absolute right-5 bottom-0 left-5 h-px"
          style={{ background: goldDim }}
        />
      </div>
    </div>
  )
}
